import copyCodeIcon from "../../../../../../../../../assets/icons/copy_code_blue.svg";
import whatsAppBlueIcon from "../../../../../../../../../assets/icons/whatsapp_blue.svg";
import sucessIcon from "../../../../../../../../../assets/icons/sucess_green.svg";
import downloadIcon from "../../../../../../../../../assets/icons/baixar_blue.svg";
import sendEmailIcon from "../../../../../../../../../assets/icons/email_blue.svg";
import checkIcon from "../../../../../../../../../assets/icons/check.svg";
import sendSmSIcon from "../../../../../../../../../assets/icons/send_sms_blue.png";
import { Button } from "../../../../../../../../generics/button";
import { useContrato } from "../../../../../../../../../context/ContratoContext";
import { Contrato } from "../../../../../../../../../services/data/dummyContratos";
import { useModal } from "../../../../../../../../../hooks/ModalContext";

export const AcordoAccordion = () => {
  const { limparNegociacoes, contratos } = useContrato();
  const { setModal } = useModal();

  function verificarPropriedadeIgual(array: Contrato[], propriedade: string) {
    return array.every(function (elemento) {
      return elemento.hasOwnProperty(propriedade);
    });
  }

  function finalizarAcordo() {
    const element = document.getElementById("neg-title");

    if (verificarPropriedadeIgual(contratos, "tabulado")) {
      setModal("Proximo Atendimento", "Atendimento");
    }

    if (element) {
      limparNegociacoes();
      element.scrollIntoView({ behavior: "smooth" });
      document.getElementById("acordo")?.removeAttribute("open");
      document.getElementById("resumo")?.removeAttribute("open");
    }
  }

  return (
    <details
      id="acordo"
      className="mb-3 w-full border border-gray-300 bg-white"
    >
      <summary className="flex w-full cursor-pointer justify-between bg-white px-4 py-3 text-xl font-medium text-gray-800 after:content-['+']">
        Proposta Efetivada
      </summary>

      <div className="px-4 py-2">
        <div className="my-4 flex w-full flex-col items-center justify-center gap-4">
          <h2 className="text-xl font-medium text-green-600">
            Proposta Efetivada com Sucesso!
          </h2>
          <div className="mb-8 flex h-20 w-20 items-center justify-center rounded-full bg-green-600">
            <img src={checkIcon} alt="" className="h-14 w-14" />
          </div>
          <div className="w-[70%] bg-green-100 px-8 text-primary">
            <p className="font-medium">
              Instrumento de pagamento enviada para os endereços abaixo:
            </p>
            <div className="grid w-full grid-cols-2 gap-2   py-2 text-primary">
              <strong>Email: </strong>
              <p>mariasilva@contato.com</p>

              <strong>WhatsApp: </strong>
              <p>(11)93938-1750</p>

              <strong>SMS: </strong>
              <p>(11)93938-1750</p>
            </div>
          </div>

          <div className="my-4 flex w-full items-center justify-around  px-4">
            <button className="btn-acordo">
              <div className="my-2 flex h-14 w-16 items-center justify-center rounded-md border border-blue-900">
                <img src={downloadIcon} alt="" />
              </div>
              Baixar boleto
            </button>
            <button className="btn-acordo">
              <div className="my-2 flex h-14 w-16 items-center justify-center rounded-md border border-blue-900">
                <img src={copyCodeIcon} alt="" />
              </div>
              Copiar código
            </button>

          </div>
        </div>
        <div className="mb-8 mt-14 flex w-full items-center justify-around gap-8">
          <button
            className="flex flex-col items-center px-2"
            onClick={() => finalizarAcordo()}
          >
            <div className="btn-finalizado">
              <img src={checkIcon} alt="" className="my-1 h-8 w-8" />
              <p>Finalizado</p>
            </div>
            <p className="wrap my-4 h-10 w-[12rem] text-center text-sm text-gray-500">
              Sem Confirmação de Entrega de Link
            </p>
          </button>
          <button
            className="flex flex-col items-center  px-2"
            onClick={() => finalizarAcordo()}
          >
            <div className="btn-finalizado">
              <img src={checkIcon} alt="" className="my-1 h-8 w-8" />
              <p>Finalizado</p>
            </div>
            <p className="wrap my-4 h-10 w-[12rem] text-center text-sm text-gray-500">
              Com Confirmação de Entrega de Link
            </p>
          </button>
          <button
            className="flex flex-col items-center px-2"
            onClick={() => finalizarAcordo()}
          >
            <div className="btn-finalizado">
              <img src={checkIcon} alt="" className="my-1 h-8 w-8" />
              <p>Finalizado</p>
            </div>
            <p className="wrap my-4 h-10 w-[12rem] text-center text-sm text-gray-500">
              Confirmado Entrega de Link + Autoriz. Pgto
            </p>
          </button>
        </div>
      </div>
    </details>
  );
};
